import React, { useState } from 'react';
import { useHistory } from 'react-router';
import { Input, Button, ErrorSummary } from 'govuk-react-jsx';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import {
  getPmcCompanyRegistrationNumber,
  setPmcCompanyRegistrationNumber,
  setCompanyData,
} from '../../features/pmc/pmcJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { checkValidCompanyRegistration } from '../../regex/regex';
import { getCompanyData } from '../../firebase';
import useTitle from '../../hooks/useTitle';

const CompanyRegistrationNumber = () => {
  const companyRegistrationNumberRedux = useSelector(
    getPmcCompanyRegistrationNumber
  );
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;

  useTitle(
    'landlordReg.CompanyRegistrationNumber.s10',
    'Enter company registration number - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const dispatch = useDispatch();
  const history = useHistory();
  const [errorMsg, setErrorMsg] = React.useState('');
  const [errorList, setErrorList] = useState([]);
  const handleCompanyRegistration = (event) => {
    dispatch(setPmcCompanyRegistrationNumber(event.target.value));
  };

  const errorMessage = copyProvider.getCopy(
    'pmcReg.CompanyRegistrationNumber.s1',
    'Enter a valid Company Registration number that consists of 8 characters and can contain letters and numbers'
  );

  const errorNotValidAPI = copyProvider.getCopy(
    'pmcReg.CompanyRegistrationNumber.s2',
    'Entered Company Registration number not recognised'
  );

  const errorAlreadyExistsAPI = copyProvider.getCopy(
    'pmcReg.CompanyRegistrationNumber.s9',
    'This number is already in use with another account'
  );

  const showError = {
    children: errorMessage,
  };

  const showErrorNotValidAPI = {
    children: errorNotValidAPI,
  };

  const showErrorAlreadyExistsAPI = {
    children: errorAlreadyExistsAPI,
  };

  const handleBtnClick = () => {
    if (checkValidCompanyRegistration.test(companyRegistrationNumberRedux)) {
      setErrorMsg(null);

      getCompanyData({ companyRegNumber: companyRegistrationNumberRedux })
        .then((response) => {
          const { data } = response;
          dispatch(setCompanyData(data));

          if (
            data !== null &&
            data.companyRegNumber === companyRegistrationNumberRedux
          ) {
            history.push('/pmcReg/confirm-business-details');
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              { ...showErrorNotValidAPI, href: '#companyRegistrationNumber' },
            ]);
          }
        })
        .catch((error) => {
          if (error.code === 'functions/already-exists') {
            setErrorMsg(showErrorAlreadyExistsAPI);
            setErrorList([
              {
                ...showErrorAlreadyExistsAPI,
                href: '#companyRegistrationNumber',
              },
            ]);
          } else {
            setErrorMsg(showErrorNotValidAPI);
            setErrorList([
              { ...showErrorNotValidAPI, href: '#companyRegistrationNumber' },
            ]);
          }
        });
    } else if (
      !checkValidCompanyRegistration.test(companyRegistrationNumberRedux)
    ) {
      setErrorMsg(showError);
      setErrorList([{ ...showError, href: '#companyRegistrationNumber' }]);
    }
  };

  const pageModel = (
    <>
      {errorList?.length > 0 && (
        <ErrorSummary
          errorList={errorList}
          titleChildren={copyProvider.getCopy(
            'Common.error-summery',
            'There is a problem'
          )}
        />
      )}
      <div className="govuk-form-group">
        <h1 className="govuk-heading-xl">
          {copyProvider.getCopy(
            'pmcReg.CompanyRegistrationNumber.s3',
            'Enter your company registration number'
          )}
        </h1>
        <p className="govuk-body">
          {copyProvider.getCopy(
            'pmcReg.CompanyRegistrationNumber.s4',
            'We will use this number to confirm the business details of your company. This is the best number to use for a fast registration.'
          )}
        </p>
        <div className="govuk-form-group">
          <div className="govuk-body">
            <Input
              errorMessage={errorMsg || null}
              hint={{
                children: copyProvider.getCopy(
                  'pmcReg.CompanyRegistrationNumber.s6',
                  'Companies House provides this number when a company first registers.'
                ),
              }}
              label={{
                children: copyProvider.getCopy(
                  'pmcReg.CompanyRegistrationNumber.s5',
                  'Company registration number'
                ),
              }}
              id="companyRegistrationNumber"
              className="govuk-input govuk-!-width-two-thirds"
              name="companyRegistration"
              type="text"
              value={companyRegistrationNumberRedux}
              onChange={(event) => handleCompanyRegistration(event)}
            />
          </div>
        </div>
      </div>
      <div className="govuk-body govuk-!-font-size-19 govuk-!-padding-bottom-6">
        <Link className="govuk-link " to="/pmcReg/company-VAT-number">
          {copyProvider.getCopy(
            'pmcReg.CompanyRegistrationNumber.s7',
            "I don't have a company registration number"
          )}
        </Link>
      </div>

      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'pmcReg.CompanyRegistrationNumber.s8',
          'Continue'
        )}
      </Button>
    </>
  );

  return pageModel;
};

export default CompanyRegistrationNumber;
